module.exports = __webpack_public_path__ + "media/images/IMG2_features-b553809a.png";